import { LoginResponseModel } from "../ResponseModel/LoginResponseModel";

const CookieUserInfo = {
    WorksI: "worksI-authorzation",
    Freee: "freee-userinfo"
}

const FindCookieByName = (name) => {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));

    if (match) 
        return match[2];
}

export class CookieAuthenModel {
    IsWIAuthorization() {
        this.Cookie = document.cookie;
        return this.Cookie.includes(CookieUserInfo.WorksI);
    }

    IsFreeeAuthorization() {
        this.Cookie = document.cookie;
        return this.Cookie.includes(CookieUserInfo.Freee);
    }

    GetWILoginModel() {
        this.Cookie = document.cookie;
        if (this.Cookie.includes(CookieUserInfo.WorksI))
            return new LoginResponseModel(JSON.parse(FindCookieByName(CookieUserInfo.WorksI))) 
    }

    GetFreeeLoginModel() {
        this.Cookie = document.cookie;
        if (this.Cookie.includes(CookieUserInfo.Freee))
            return FindCookieByName(CookieUserInfo.Freee);
    }
}